import { render, staticRenderFns } from "./HuellaCarbono.vue?vue&type=template&id=44701ab2&scoped=true&"
import script from "./HuellaCarbono.vue?vue&type=script&lang=ts&"
export * from "./HuellaCarbono.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44701ab2",
  null
  
)

export default component.exports